import { useConfigContext } from "@/app";
import { Image } from "antd-mobile";
import { PropsWithChildren } from "react";

export type ImageLocalProps = PropsWithChildren<{
  className?: string;
  src: string;
}>;

export const ImageLocal = ({ src }: ImageLocalProps) => {
  const { getSourcePath } = useConfigContext();
  return (
    <>
      <Image src={src && getSourcePath(src)}></Image>
    </>
  );
};
